import { RadioItemConfigType } from 'src/lib/types/random'
export const CodConfirmationRadioGroupOptions: RadioItemConfigType[] = [
  {
    label: 'Verify address phone number for COD orders on confirmation/thank you page',
    valueType: 'POST_COD'
  },
  {
    label: 'Verify address phone numbers before placing a COD order',
    valueType: 'PRE_COD'
  }
]
